import React, { Component } from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";

class Gallery extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";

    return (
      <div id="custom_gallery_view"  className="ltn__img-slider-area">
        <div className="container-fluid">
          <div className="row ltn__image-slider-2-active slick-arrow-1 slick-arrow-1-inner ltn__no-gutter-all">
            {this.props.value &&
              this.props.value.map((data, key) => {
				console.log("sdsdssdssasaasasasa",data, key);
                return (
                  <React.Fragment key={key}>
                    <div className="col-lg-12">
                      <div className="ltn__img-slide-item-4">
                        <a
                          href={data.image}
                          data-rel="lightcase:myCollection"
                        >
                          <img
                            src={data.image}
                            alt="Image"
                          />
                        </a>
                        {/* <div className="ltn__img-slide-info">
						<div className="ltn__img-slide-info-brief gp-top">
							<h6>Heart of NYC</h6>
							<h1><Link to="/portfolio-details">Manhattan </Link></h1>
						</div>
						<div className="btn-wrapper go-top">
							<Link to="/portfolio-details" className="btn theme-btn-1 btn-effect-1 text-uppercase">Details</Link>
						</div>
						</div> */}
                      </div>
                    </div>
                  </React.Fragment>
                );
              })}
          </div>
        </div>
      </div>
    );
  }
}

export default Gallery;
